import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { InView } from 'react-intersection-observer';
import projectData from '../data/project.json';
import '../style/slide.css';

function ProjectSlide() {
  return (
    <section>
      {projectData.map((project, index) => {
        const isReverse = index % 2 !== 0;

        // console.log(project.bg);
        return (
          <InView key={project.id} threshold={0.4} triggerOnce={false}>
            {({ inView, ref }) => (
              <article
                className={`slide-wrapper ${isReverse ? 'reverse' : ''}`}
                ref={ref}
              >
                {/* 이미지 */}
                <motion.div
                  className="slide-img"
                  initial={{ x: isReverse ? 100 : -100, opacity: 0 }}
                  animate={inView ? { x: 0, opacity: 1 } : {}}
                  transition={{ duration: 0.8 }}
                  style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/images/${project.bg})` }}
                >
                  <img src={`${process.env.PUBLIC_URL}/images/${project.img}`}  alt={project.title} />
                </motion.div>

                {/* 텍스트 */}
                <motion.div
                  className="slide-text"
                  initial={{ x: isReverse ? -100 : 100, opacity: 0 }}
                  animate={inView ? { x: 0, opacity: 1 } : {}}
                  transition={{ duration: 0.8 }}
                >
                  <Link to={project.url} target="_blank" rel="noopener noreferrer" >🔗View</Link>
                  <img src={`${process.env.PUBLIC_URL}/images/${project.logo}`} alt={project.title}/>
                  <p><span>프로젝트명</span> : {project.name}</p>
                  <p><span className='day'><span>작</span><span>업</span><span>일</span></span> : {project.date}일</p>
                  <p><span className='layout'>레이아웃</span> : {project.layout}</p>
                  <p><span className='language'>개발언어</span> : {project.language}</p>
                  <p><span>프로젝트 설명</span></p>
                  <p>{project.info1}</p>
                  <p>{project.info2}</p>
                  <p>{project.info3}</p>
                  <Link to={project.notion} title='노션으로 이동하기' target="_blank" rel="noopener noreferrer" className='notion_btn'>
                    <button>자세히보기</button>
                  </Link>
                </motion.div>
              </article>
            )}
          </InView>
        );
      })}
    </section>
  );
}

export default ProjectSlide;
